export default abstract class CaminhaoRoutes {
  static readonly LIST: string = '/caminhoes'
  static readonly CREATE: string = '/caminhoes/register'
}
